<template>
    <!-- 完成待办弹窗 -->
    <el-dialog
        title="完成待办"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        append-to-body
        width="480px"
        @close="close"
    >
        <div class="complete-content">
            <!-- 待办名称 -->
            <div class="task-name">
                <span class="label">待办标题：</span>
                <span>{{ taskTitle }}</span>
            </div>
            <!-- 处理备注 -->
            <el-form :model="formData" ref="formData" class="MT20">
                <el-form-item label="处理备注：">
                    <el-input
                        type="textarea"
                        v-model.trim="formData.completeContent"
                        placeholder="请输入处理备注（选填）"
                        maxlength="500"
                        show-word-limit
                        :rows="4"
                    ></el-input>
                </el-form-item>
            </el-form>
            <!-- 完成提示 -->
            <el-alert title="完成后该任务将整体结束，所有处理人将不再收到提醒" type="warning" :closable="false" show-icon
                class="MT20"></el-alert>
        </div>
        <div slot="footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="submit">确认完成</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'Complete',
    data() {
        return {
            dialogVisible: false, // 弹窗显示状态
            btnLoading: false, // 提交按钮加载状态
            taskId: '', // 待办ID
            taskTitle: '', // 待办名称
            formData: {
                completeContent: '', // 处理备注
            },
        };
    },
    methods: {
        // 关闭弹窗
        close() {
            this.dialogVisible = false;
            this.taskId = '';
            this.taskTitle = '';
            this.formData.completeContent = '';
        },
        // 打开完成弹窗
        open(row) {
            this.taskId = row?.id || '';
            this.taskTitle = row?.title || '';
            this.dialogVisible = true;
        },
        // 提交完成
        async submit() {
            this.btnLoading = true;
            try {
                const res = await this.$request({
                    url: '/pendingtask/complete',
                    method: 'post',
                    data: {
                        pendingTaskId: this.taskId,
                        completeContent: this.formData.completeContent,
                    },
                });
                const { state, msg } = res.data;
                if (state == 1) {
                    this.$message.success('已完成');
                    this.close();
                    this.$emit('onSuccess');
                } else {
                    this.$message.error(msg || '操作失败');
                }
            } catch (err) {
                this.$message.error('操作失败');
            } finally {
                this.btnLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>

</style>